<template>
  <v-menu 
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="info">
          anchor
        </v-icon>
      </v-btn>
    </template>
    
    <v-card>
      <div class="font-weight-bold py-3 mx-5">
        Probation Result
      </div>

      <v-radio-group
        v-model="localProbation.pass_or_fail"
        v-validate="'required'"
        row
        class="mt-0 mx-5"
        :error-messages="errors.collect('pass_or_fail')"
        data-vv-name="pass_or_fail"  
        data-vv-as="probation result"   
      >
        <v-radio
          label="Pass"
          value="1"
        />
        <v-radio
          label="Fail"
          value="0"
        />
      </v-radio-group>

      <v-menu
        v-model="probationStartDateMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="probationEffectiveDateDisplay"
            v-validate="'required'"
            label="Effective Date"
            outlined
            :error-messages="errors.collect('probationEffectiveDateDisplay')"
            data-vv-name="probationEffectiveDateDisplay"  
            data-vv-as="effective date"      
            readonly
            class="fix-date-picker-outline-overlap mx-5"
            v-on="on"
          />
        </template>
        <v-date-picker
          v-model="localProbation.effective_date"
          @input="probationStartDateMenu = false"
        />
      </v-menu>

      <v-textarea
        v-model="localProbation.remarks"
        class="mx-5"
        :rows="3"
        auto-grow
        outlined
        label="Remark"
      />

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10" 
          @click="menu = false"
        >
          No
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary" 
          class="white--text px-10"         
          @click="submitForm"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      probation: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        menu: null,
        progressing: false,
        probationStartDate: null,
        probationStartDateMenu: false,
        localProbation: {},
      }
    },
    computed: {
      probationEffectiveDateDisplay () {
        return this.localProbation.effective_date ? this.$moment(this.localProbation.effective_date, 'YYYY-MM-DD').format('D MMM YYYY') : ''
      },
    },

    watch: {
      menu: function (value) {
        if (!value) this.localProbation = {}
        
        this.localProbation = { ...this.probation }
      },
    },

    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.progressing = true

            this.$api.employeeProbations().confirm(this.probation.id, { remarks: this.localProbation.remarks, effective_date: this.localProbation.effective_date, pass_or_fail: this.localProbation.pass_or_fail })
              .then(response => {
                if (response.status === 200) {
                  this.$emit('confirmed')
                  this.$snack({ message: response.data.status })
                }
              })
              .catch(error => {
                if (error.response.status === 405 || error.response.status === 500) {
                  this.$snack({ 
                    color: 'error',
                    message: error.response.data.status, 
                  })
                }
              })
              .then(() => {
                this.menu = false
                this.progressing = false
              })  
          })
      },
    },
  }
</script>

<style scoped>
.fix-date-picker-outline-overlap >>> label{
  background: white;
  padding-right:10px
}
</style>
